import { CaseUserGroup, BulkAssignmentCase } from '@/api/apis/case';
import { getFullName } from '@/utils/helpers';
import { UserAvatarWithPrimary } from '../../AssignmentTables/components';

type BulkAssignmentUsersCellProps = {
  assignedEmployees: BulkAssignmentCase['assignedEmployees'];
  selectedGroup?: CaseUserGroup;
};

export const BulkAssignmentUsersCell = ({ assignedEmployees, selectedGroup }: BulkAssignmentUsersCellProps) => {
  if (!selectedGroup) return null;

  const employees = assignedEmployees[selectedGroup];

  if (!employees?.length) return null;

  return (
    <div className="items-center text-m-r flex gap-2 flex-wrap">
      {employees.map(({ employeeId, user, isPrimary }) => (
        <div key={employeeId} className="flex items-center text-m-r">
          <UserAvatarWithPrimary
            name={getFullName(user.firstName, user.lastName)}
            photo={user.photoPath}
            isPrimary={isPrimary}
          />
          {getFullName(user.firstName, user.lastName)}
        </div>
      ))}
    </div>
  );
};
